import { render } from "./PremiumModal.vue?vue&type=template&id=a3d4a350&scoped=true"
import script from "./PremiumModal.vue?vue&type=script&lang=js"
export * from "./PremiumModal.vue?vue&type=script&lang=js"

import "./PremiumModal.vue?vue&type=style&index=0&id=a3d4a350&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d4a350"]])

export default __exports__